import React from "react";
import { observer } from "mobx-react";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel
} from "@material-ui/core";
import PrimaryButton from "@components/buttons/PrimaryButton";
import { UserSelectorStore } from "./UserSelectorStore";
import UserList from "./UserList";
import { useLocale } from "@hooks";
import { useGetUserSelectorUsersQuery } from "@graphql";

type Props = {
  store: UserSelectorStore;
};

export const UserSelector = ({ store }: Props) => {
  const { locale } = useLocale();

  const { data, loading } = useGetUserSelectorUsersQuery({
    skip: !store.isUserSelectorOpen
  });

  if (!store.isUserSelectorOpen) {
    return null;
  }

  const users = data?.users ?? [];
  const teams = data?.teams.map((x) => x.Name) ?? [];

  const items = store.getUserList(users, teams);

  return (
    <Dialog open={store.isUserSelectorOpen} onClose={store.close} data-test="UserList">
      <DialogContent>
        <UserList
          items={items}
          onSelect={store.select}
          multi={store.multi}
          selectedUsers={store.selectedUsers}
          showDisabled={store.showDisabled}
          loading={loading}
        />
      </DialogContent>

      <DialogActions
        style={{ justifyContent: "center", paddingLeft: 24, paddingRight: 24 }}
      >
        <FormControlLabel
          label="Include disabled"
          control={<Checkbox onChange={(_, v) => (store.showDisabled = v)} />}
          style={{ marginRight: "auto" }}
        />

        {store.multi && (
          <PrimaryButton disabled={false} onClick={store.submit} type="submit">
            {locale.Save}
          </PrimaryButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default observer(UserSelector);
